import { useState, useEffect } from "react";
import serverURL from "../../config/serverConfig";
import { useLocation, useNavigate } from "react-router-dom";
import { useClientProjects, updateClient, deleteClient } from "../../hooks/db";
import ProjectBlobClient from "../projects/ProjectBlobClient";
import { Link } from "react-router-dom";
import ClientIncome from "./ClientIncome";
import { ArrowLeft, ArrowUpDown, CaseSensitive, Pencil, X, Trash2 } from "lucide-react";

const MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];


export default function Client(props) {

    const location = useLocation();
    const navigate = useNavigate();
    const client_id = location.state?.client_id || props.clientID;
    //const client_ID = Number(props.clientID);
    console.log(typeof(client_id))
    const [clientInfo, setClientInfo] = useState();
    console.log(client_id)
    const clientProjects = useClientProjects(client_id);
    console.log("Client Projects: ", clientProjects);

    useEffect(() => {
        if (!client_id) return;

        fetch(`${serverURL}getClient`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ client_id }),
        })
            .then(response => response.json())
            .then(jsonData => {
                setClientInfo(jsonData[0]);
                console.log("Client info fetched:", jsonData);
            })
            .catch(error => {
                console.error("Error fetching projects:", error);
            });

    }, []);

    const [editing, setEditing] = useState(false);
    const [tempClient, setTempClient] = useState(null);
    const [confirmDelete, setConfirmDelete] = useState(false);

    const toggleEditing = async () => {
        if (editing) {
            try {
                const updated = await updateClient(tempClient);
                setClientInfo(updated);
            } catch (err) {
                console.error("Error updating client:", err);
            }
            setConfirmDelete(false);
        } else {
            setTempClient(clientInfo);
        }
        setEditing(prev => !prev);
    };

    const handleDelete = async () => {
        try {
            await deleteClient(client_id);
            navigate(-1);
        } catch (err) {
            console.error("Error deleting client:", err);
        }
    };

    const [completedSort, setCompletedSort] = useState("date"); // "date" | "alpha"

    const parseCurrency = (val) => Number(String(val).replace(/[^0-9.-]+/g, "")) || 0;

    const activeProjects  = clientProjects?.filter(p => p.status !== "Complete") ?? [];
    const completedUnpaid = clientProjects?.filter(p => p.status === "Complete" && parseCurrency(p.paid) < parseCurrency(p.fee)) ?? [];
    const completedPaid   = clientProjects?.filter(p => p.status === "Complete" && parseCurrency(p.paid) >= parseCurrency(p.fee)) ?? [];

    const sortAlpha = (projects) =>
        [...projects].sort((a, b) => a.title.localeCompare(b.title));

    const groupByMonth = (projects) => {
        const sorted = [...projects].sort((a, b) => new Date(b.due_date) - new Date(a.due_date));
        const groups = {};
        sorted.forEach(p => {
            const d = new Date(p.due_date);
            const key = `${MONTHS[d.getUTCMonth()]} ${d.getUTCFullYear()}`;
            if (!groups[key]) groups[key] = [];
            groups[key].push(p);
        });
        return Object.entries(groups); // [ [monthLabel, [projects]], ... ]
    };

    const ProjectLink = ({ project }) => (
        <Link to="/project" state={{ project_id: project.project_id }} key={project.project_id} className="blobLink">
            <ProjectBlobClient project={project} />
        </Link>
    );

    const ProjectList = ({ projects }) => (
        <div className="flex flex-col gap-1">
            {projects.map(p => <ProjectLink key={p.project_id} project={p} />)}
        </div>
    );

    const GroupedProjectList = ({ projects }) => {
        const groups = groupByMonth(projects);
        return (
            <div className="flex flex-col gap-3">
                {groups.map(([month, monthProjects]) => (
                    <div key={month}>
                        <div className="text-[9px] uppercase tracking-[0.18em] font-semibold text-[#555] mb-1.5 pl-1">
                            {month}
                        </div>
                        <div className="flex flex-col gap-1">
                            {monthProjects.map(p => <ProjectLink key={p.project_id} project={p} />)}
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    const CompletedSection = ({ title, projects, accentColor }) => (
        projects.length > 0 ? (
            <div className="gradientBG p-3 pt-2 w-full">
                <h4 className="uppercase text-[10px] tracking-[0.12em] font-semibold text-[#aaa] flex items-center gap-2">
                    {accentColor && <span className="inline-block w-2 h-2 rounded-full" style={{ backgroundColor: accentColor }}/>}
                    {title}
                    <span className="ml-auto text-[#444] font-normal">{projects.length}</span>
                </h4>
                <div className="hBar mt-[7px] mb-[10px]"></div>
                <div className="overflow-y-auto max-h-[320px] pr-1">
                    {completedSort === "alpha"
                        ? <ProjectList projects={sortAlpha(projects)} />
                        : <GroupedProjectList projects={projects} />
                    }
                </div>
            </div>
        ) : null
    );

    const SectionBlock = ({ title, projects, accentColor }) => (
        projects.length > 0 ? (
            <div className="gradientBG p-3 pt-2 w-full">
                <h4 className="uppercase text-[10px] tracking-[0.12em] font-semibold text-[#aaa] flex items-center gap-2">
                    {accentColor && <span className="inline-block w-2 h-2 rounded-full" style={{ backgroundColor: accentColor }}/>}
                    {title}
                    <span className="ml-auto text-[#444] font-normal">{projects.length}</span>
                </h4>
                <div className="hBar mt-[7px] mb-[10px]"></div>
                <div className="flex flex-col gap-1">
                    <ProjectList projects={projects} />
                </div>
            </div>
        ) : null
    );

    return (
        <div id="clientPage" className="max-w-[1400px] m-auto px-8">
            {clientInfo ? (
                <div className="py-6 flex flex-col w-full">
                    <button
                        onClick={() => navigate(-1)}
                        className="flex items-center gap-1.5 text-[#666] hover:text-[#ffee00] text-xs uppercase tracking-wider font-medium mb-4 transition-colors duration-200 w-fit"
                    >
                        <ArrowLeft size={14}/> Back
                    </button>
                    <div className="flex items-center justify-between mb-3">
                        {editing ? (
                            <input
                                className="text-xl uppercase font-semibold tracking-wider bg-transparent border-b border-[#555] focus:outline-none focus:border-[#ffee00] text-white w-[260px]"
                                value={tempClient.name}
                                onChange={e => setTempClient(prev => ({ ...prev, name: e.target.value }))}
                            />
                        ) : (
                            <h2 className="text-xl uppercase tracking-wider">{clientInfo.name}</h2>
                        )}
                        <div className="flex items-center gap-3">
                        <button onClick={toggleEditing} className="text-[#666] hover:text-[#ffee00] transition-colors duration-150">{editing ? <X size={16}/> : <Pencil size={16}/>}</button>
                        {editing && (
                            confirmDelete ? (
                                <div className="flex items-center gap-2">
                                    <span className="text-xs text-[#aaa]">Delete client?</span>
                                    <button
                                        onClick={handleDelete}
                                        className="text-xs px-2 py-0.5 rounded bg-red-700 hover:bg-red-600 text-white transition-colors duration-150"
                                    >
                                        Confirm
                                    </button>
                                    <button
                                        onClick={() => setConfirmDelete(false)}
                                        className="text-xs px-2 py-0.5 rounded bg-[#333] hover:bg-[#444] text-[#aaa] transition-colors duration-150"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            ) : (
                                <button
                                    onClick={() => setConfirmDelete(true)}
                                    className="text-[#555] hover:text-red-500 transition-colors duration-150"
                                    title="Delete client"
                                >
                                    <Trash2 size={16}/>
                                </button>
                            )
                        )}
                        </div>
                    </div>
                    <div className="grid grid-cols-2 gap-2 py-4 px-4 rounded-xl bg-[#181818] border border-[rgba(255,255,255,0.05)] text-sm mb-2">
                        <p className="flex items-center gap-2">
                            <strong className="text-[#888]">Email</strong>
                            {editing ? (
                                <input
                                    className="bg-transparent border-b border-[#555] focus:outline-none focus:border-[#ffee00] text-white text-sm w-[180px]"
                                    value={tempClient.email ?? ""}
                                    onChange={e => setTempClient(prev => ({ ...prev, email: e.target.value }))}
                                />
                            ) : clientInfo.email}
                        </p>
                        <p className="flex items-center gap-2">
                            <strong className="text-[#888]">Phone</strong>
                            {editing ? (
                                <input
                                    className="bg-transparent border-b border-[#555] focus:outline-none focus:border-[#ffee00] text-white text-sm w-[140px]"
                                    value={tempClient.phone ?? ""}
                                    onChange={e => setTempClient(prev => ({ ...prev, phone: e.target.value }))}
                                />
                            ) : clientInfo.phone}
                        </p>
                    </div>

                    {clientProjects && clientProjects.length > 0 ? (
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4 items-start">

                            {/* Left: Active */}
                            <div className="flex flex-col gap-3">
                                <SectionBlock title="Active Projects" projects={activeProjects} accentColor="#ff7700" />
                                {activeProjects.length === 0 && (
                                    <div className="gradientBG p-4 text-xs text-[#444] text-center tracking-wide uppercase">No active projects</div>
                                )}
                            </div>

                            {/* Center: Completed (scrollable) */}
                            <div className="flex flex-col gap-3">
                                {/* Sort controls */}
                                {(completedUnpaid.length > 0 || completedPaid.length > 0) && (
                                    <div className="flex items-center gap-1 self-end">
                                        <span className="text-[9px] uppercase tracking-wider text-[#444] mr-1">Sort</span>
                                        <button
                                            onClick={() => setCompletedSort("date")}
                                            className={`flex items-center gap-1 text-[10px] px-2 py-1 rounded-md transition-all duration-150 ${completedSort === "date" ? "bg-[rgba(255,238,0,0.1)] text-[#ffee00] border border-[rgba(255,238,0,0.25)]" : "text-[#555] hover:text-[#aaa]"}`}
                                        >
                                            <ArrowUpDown size={10}/> Date
                                        </button>
                                        <button
                                            onClick={() => setCompletedSort("alpha")}
                                            className={`flex items-center gap-1 text-[10px] px-2 py-1 rounded-md transition-all duration-150 ${completedSort === "alpha" ? "bg-[rgba(255,238,0,0.1)] text-[#ffee00] border border-[rgba(255,238,0,0.25)]" : "text-[#555] hover:text-[#aaa]"}`}
                                        >
                                            <CaseSensitive size={10}/> A–Z
                                        </button>
                                    </div>
                                )}
                                <CompletedSection title="Completed — Unpaid" projects={completedUnpaid} accentColor="#ffee00" />
                                <CompletedSection title="Completed" projects={completedPaid} accentColor="#46C408" />
                                {completedUnpaid.length === 0 && completedPaid.length === 0 && (
                                    <div className="gradientBG p-4 text-xs text-[#444] text-center tracking-wide uppercase">No completed projects</div>
                                )}
                            </div>

                            {/* Right: Income */}
                            <div className="gradientBG p-3 pt-2">
                                <ClientIncome clientProjects={clientProjects} />
                            </div>

                        </div>
                    ) : (
                        <p className="text-sm text-[#555] mt-4">No projects found for this client.</p>
                    )}
                </div>
            ) : (
                <p className="text-sm text-[#555] p-6">Loading client information...</p>
            )}
        </div>
    )
}